var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        closeOutside: false,
        titulo: "Alteração de perfil",
        width: 1000
      },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _vm.usuario
            ? _c(
                "validation-observer",
                {
                  ref: "observer",
                  staticClass: "margin-top",
                  attrs: { tag: "form" }
                },
                [
                  _c("app-input-perfil", {
                    staticClass: "no-padding",
                    attrs: {
                      usuarioTipo: _vm.usuario.pessoa.tipo,
                      pessoa: _vm.usuario.pessoa
                    },
                    model: {
                      value: _vm.perfis,
                      callback: function($$v) {
                        _vm.perfis = $$v
                      },
                      expression: "perfis"
                    }
                  }),
                  _vm.hasInserirMunicipio
                    ? _c(
                        "div",
                        { staticClass: "margin-top" },
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: { label: "Município:" }
                                      }),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "full-width input",
                                          class: { erro: errors.length },
                                          attrs: { filterable: "filterable" },
                                          model: {
                                            value: _vm.idMunicipio,
                                            callback: function($$v) {
                                              _vm.idMunicipio = $$v
                                            },
                                            expression: "idMunicipio"
                                          }
                                        },
                                        _vm._l(_vm.municipios, function(
                                          municipio
                                        ) {
                                          return _c("el-option", {
                                            key: municipio.id,
                                            attrs: {
                                              label: municipio.nome,
                                              value: municipio.id
                                            }
                                          })
                                        }),
                                        1
                                      ),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2936972605
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { staticClass: "margin-top", attrs: { span: 24 } },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required", name: "observacao" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: "Observação:",
                                      required: true
                                    }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "Observação..."
                                    },
                                    model: {
                                      value: _vm.observacao,
                                      callback: function($$v) {
                                        _vm.observacao = $$v
                                      },
                                      expression: "observacao"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          970491
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "margin-top-30", attrs: { span: 24 } },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "", name: "arquivo" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: { label: "Anexo:", required: false }
                                  }),
                                  _c("app-upload-area", {
                                    attrs: {
                                      id: "modalAlterarPerfil",
                                      target: _vm.urlUpload,
                                      fileType: _vm.validExtensions,
                                      onSuccess: _vm.onSuccess,
                                      errors: errors,
                                      hasDownloadButton: false
                                    },
                                    on: { removerDocumento: _vm.removeArquivo },
                                    model: {
                                      value: _vm.documento,
                                      callback: function($$v) {
                                        _vm.documento = $$v
                                      },
                                      expression: "documento"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1172120074
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "el-button",
              {
                staticClass: "cancelarButton",
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-times" }), _vm._v(" Cancelar")]
            ),
            _c(
              "el-button",
              {
                key: "botao-confirma",
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.save()
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-check" }), _vm._v(" Confirmar")]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-329d6532", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-329d6532","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/seguranca/components/AppModalAlterarPerfil.vue
// module id = null
// module chunks = 